
















































import Vue from 'vue';

export default Vue.extend({
    name: 'save-status',

    props: {
        dirty:      Boolean,
        lastStatus: Number,
        saving:     Boolean,
        error:      String,
    },

    computed: {
        formattedDate() : string {
            return new Date(this.lastStatus).toLocaleTimeString('en-us');
        },

        message() : string {
            let msg = '';
            if (this.dirty)
                msg = 'Changes pending upload. ';
            else
                msg = 'No new changes. ';
            if (this.lastStatus)
                msg += `Last saved at ${this.formattedDate}.`;
            return msg;
        },
    },
});
